if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.quantity = {
          Single: 1,
          Double: 2,
          Team: 5,
          '5 Pack': 5,
        };
        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        const isLandingPage = document.querySelector("#landing-page-form");
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner")?.classList.remove(
          "hidden"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        let jsonData = document.querySelector(
          '#shopify-product[type="application/json"]'
        );

        if (jsonData) {
          jsonData = JSON.parse(jsonData.textContent);
          this.variantData = this.variantData || jsonData;

          if (
            formData.get("sections_url") == "/products/black-card" ||
            formData.get("sections_url") == "/products/dot-thin-1" ||
            formData.get("sections_url") == "/products/dot-classic-1" ||
            formData.get("sections_url") == "/products/dot-band" ||
            formData.get("sections_url") == "/products/dot-metal" ||
            formData.get("sections_url") == "/products/dot-wallet-1" ||
            formData.get("sections_url") == "/products/dot-display"
          ) {
            let singleVariant;
            if (formData.get("sections_url") == "/products/dot-metal") {
              const version = "2.0";
              singleVariant = this.variantData.find(
                (variant) =>
                  variant.option1 == formData.get("Color") &&
                  variant.option2 == "Single" &&
                  variant.option3 == version
              );
            } else if (formData.get("sections_url") == "/products/dot-band") {
              singleVariant = this.variantData.find(
                (variant) =>
                  variant.option1 == formData.get("Color") &&
                  variant.option2 == "Single" &&
                  variant.option3 == formData.get("Version")
              );
            } else if (formData.get("sections_url") == "/products/black-card") {
              const currentProduct = document.querySelector(".product__buy .card-upsell-input:checked")?.value || "Standard";
              if (currentProduct === "Metal") {
                const metalVariantData = JSON.parse(document.getElementById("shopify-metal-product").textContent);
                singleVariant = metalVariantData?.find(
                  (variant) =>
                    variant.option1 == formData.get("Color") &&
                    variant.option2 == "Single" &&
                    variant.option3 == "2.0"
                );
              } else {
                singleVariant = this.variantData.find(
                  (variant) =>
                    variant.option1 == formData.get("Color") &&
                    variant.option2 == "Single"
                );
              }
            } else {
              singleVariant = this.variantData.find(
                (variant) =>
                  variant.option1 == formData.get("Color") &&
                  variant.option2 == "Single"
              );
            }

            formData.set("quantity", this.quantity[formData.get("Quantity")]);
            formData.set("id", singleVariant.id);
          }
        }

        const type = formData.get("properties[type]");
        const color = formData.get("properties[Color]");
        const logoFile = formData.get("properties[Logo]");
        const cardFile = formData.get("properties[Card Logo]");
        const dotFile = formData.get("properties[Dot Logo]");
        const thinFile = formData.get("properties[Thin Logo]");
        const notes = formData.get("properties[Notes]");

        if (type) {
          if (!notes) {
            formData.set("properties[Notes]", "none");
          }

          if (!color) {
            formData.set("properties[Color]", "#ffffff");
          }

          if (logoFile && logoFile.name === "") {
            formData.set("properties[Logo]", "none");
            formData.set("properties[Logo File Name]", "none");
          }

          if (logoFile && logoFile.name !== "" && type !== "dot.bundle") {
            formData.set("properties[Logo File Name]", logoFile.name);
          } else if (logoFile && type === "dot.bundle") {
            if (logoFile.name !== "") {
              formData.set("properties[Card Logo]", logoFile);
              formData.set("properties[Dot Logo]", logoFile);
              formData.set("properties[Thin Logo]", logoFile);

              formData.set("properties[Logo File Name]", logoFile.name);
              formData.set("properties[Card File Name]", logoFile.name);
              formData.set("properties[Dot File Name]", logoFile.name);
              formData.set("properties[Thin File Name]", logoFile.name);
            } else {
              formData.set("properties[Card Logo]", "none");
              formData.set("properties[Dot Logo]", "none");
              formData.set("properties[Thin Logo]", "none");

              formData.set("properties[Card File Name]", "none");
              formData.set("properties[Dot File Name]", "none");
              formData.set("properties[Thin File Name]", "none");

              formData.delete("properties[Logo]");
              formData.delete("properties[Logo File Name]");
            }
          } else {
            cardFile &&
              formData.set("properties[Card File Name]", cardFile.name);
            dotFile && formData.set("properties[Dot File Name]", dotFile.name);
            thinFile &&
              formData.set("properties[Thin File Name]", thinFile.name);
          }
          formData.delete("properties[type]");
        }

        config.body = formData;

        const previousCart = await axios.get("/cart.js");

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            // setInitialRecommendations();
            checkDiscountApplied();
            // setBundleImage();
            const cartItems = document.querySelector('cart-drawer-items');
            if (cartItems) {
              cartItems.addInclusions();
            }
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner")?.classList.add(
              "hidden"
            );
            if (isLandingPage !== null || isLandingPage !== undefined) {
              window.history.pushState({}, "", `/pages/${landingPageSlug}`);
              window.location.href = "/cart/checkout";
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
